import { render, staticRenderFns } from "./ClientRecordDetail.vue?vue&type=template&id=d35ec4b2&scoped=true"
import script from "./ClientRecordDetail.vue?vue&type=script&lang=js"
export * from "./ClientRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./ClientRecordDetail.vue?vue&type=style&index=0&id=d35ec4b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35ec4b2",
  null
  
)

export default component.exports